import { Col, Input, message, Row, Select, Spin, Tabs } from "antd";
import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import IconClose from "../../../assets/images/IconClose.svg"
import Button_v2 from "./Button_v2";
import { EmailIcon, PrintIcon } from "../../common/CustomIcon";
import { fetchBillingDetails, getBillingActivities, getContactEmails, getEmailSubjectLine, printBillingPdf, reapproveBillings, regenerateInvoiceWithNewLos, SendInvoiceEmail, updateInvoiceCharges, updateInvoiceLines, deleteInvoiceLine } from "../../api/Billing";
import { findSpanValue, getFMPOrderFromInvoice } from "../../helpers/billing";
import { renderAlertMessage, updatePicSettingsWithBol } from "../../helpers/common";
import userStore from "../../stores/UserStore";
import { fetchOrganizationDetails } from "../../api/Organisations";
import AppConfig from "../../config/AppConfig";
import { getOrderTypeIcon } from "../../components/orders/OrderTypeIcons";
import AddressInfo from "../../components/common/AddressInfo";
import { borderCollapseInherit, fontSize10 } from "../../helpers/invoice_styles";
import I18n from "../../common/I18n";
import { alertMessage, base64ToPdf, checkNegitive, findNumberTotal, findTotal } from "../../common/Common";
import _ from "lodash";
import BaseModal from "../../components/BaseModal";
import { FormItem, Search } from "../../common/UIComponents";
import { validateEmailList } from "../../components/billing_screen/helpers";
import TextArea from "antd/lib/input/TextArea";
import { UserContext } from "../../context/UserContext";
import { OrgContext } from "../../context/OrgContext";
import { fetchTechnicians, fetchUsers } from "../../api/UsersApi";
import { fetchAccountAccessorials, fetchAccountConfigs, fetchOrderTypeLos } from "../../api/Account";
import { fetchAccountShortLos } from "../../api/Los";
import InvoiceDriverPay from "./InvoiceDriverPay";
import InvoiceActivities from "./InvoiceActivities";
import InvoiceChargesSection from './InvoiceChargesSection';
import ChargesSection from '../../components/billing/ChargesSection';

const InvoiceDetailsDrawer = ({ order, closeDrawer, account,refreshDetails ,
    ...props }) => {

    const { TabPane } = Tabs;

    const [activeKey, setActiveKey] = useState("details")
    const [isSpinning, setIsSpinning] = useState(false)
    const [isApproving, setIsApproving] = useState(false)
    const [isFetchingFullDetails, setIsFetchingFullDetails] = useState(false)
    const [currentInvoice, setCurrentInvoice] = useState({})
    const [activeRecordId, setActiveRecordId] = useState(null);
    const [orgLogo, setOrgLogo] = useState(null)
    const [showEmailModal, setShowEmailModal] = useState(false)
    const [emailSubject, setEmailSubject] = useState("")
    const [emailDesc, setEmailDesc] = useState("")
    const [emailContacts, setEmailContacts] = useState([])
    const [billingEmails, setBillingEmails] = useState([])
    const [isEmailLoading, setIsEmailLoading] = useState(false)
    const [isSendingMail, setIsSendingMail] = useState(false)
    const [consolidatedOrderNumbers, setConsolidatedOrderNumbers] = useState(null)
    const [isDriverSettlementApproved, setIsDriverSettlementApproved] = useState(null)
    const [isPickupByDriver, setIsPickupByDriver] = useState(false)
    const [pickupOrderDriverId, setPickupOrderDriverId] = useState("")
    const [pickupOrderAmount, setPickupOrderAmount] = useState(null)
    const [showActions, setShowActions] = useState(true)
    const [isInvoiceLocked, setIsInvoiceLocked] = useState(false)
    const [isOnHold, setIsOnHold] = useState(false)
    const [defaultTransportationChargeGLCode, setDefaultTransportationChargeGLCode] = useState("")
    const [ikeaChargesrecord, setIkeaChargesrecord] = useState([])
    const [drivers, setDrivers] = useState([])
    const [driversList, setDriversList] = useState([])
    const [accessorials, setAccessorials] = useState([])
    const [isLocked, setIsLocked] = useState(null)
    const [filteredOrdersForActivities, setFilteredOrdersForActivities] = useState([])
    const [filterOrderIds, setFilterOrderIds] = useState([])
    const [billingActivitiesList, setBillingActivitiesList] = useState([])
    const [filteredBillingActivitiesList, setFilteredBillingActivitiesList] = useState([])
    const [levelOfServices, setLevelOfServices] = useState([])
    const [losConfig, setLosConfig] = useState(null)
    const [invoiceLos, setInvoiceLos] = useState({})
    const [currentLos, setCurrentLos] = useState({})
    const [config, setConfig] = useState({})
    const [technicians, setTechnicians] = useState([])
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [rawInvoice, setRawInvoice] = useState({})

    const decimalPoints = window.localStorage.getItem('round_off_decimals')
    const { orgSettings: organizationSettings } = useContext(OrgContext);
    const orgData = useContext(OrgContext);
    const userContext = useContext(UserContext);
    const isTemplateZoneBilling = currentInvoice?.order_group_type === "TEMPLATE"

    useEffect(() => {
        getBillingDetails(order.id)
        setIsLocked(getInvoiceOrders().filter(order => order.is_locked == 'true').length > 0)
    }, [order.id]);

    const getOrgLogo = () => {
        const orgId = userStore.getStateValue("selectedOrg");
        fetchOrganizationDetails(orgId).then((result) => {
            if (result.success) {
                const organization = result.organization || {};
                organization.logo =
                    !isEmpty(organization.logo) && organization.logo.url
                        ? organization.logo.url
                        : "";

                if (organization.logo) {
                    setOrgLogo(organization.logo)
                } else if (!isEmpty(orgId)) {
                    const urlToFile = `${AppConfig.baseUrl}/org_logos/${orgId}/org_logo.png`;
                    fetch(urlToFile).then((response) => {
                        if (response.status === 200) {
                            setOrgLogo(urlToFile)
                        }
                    });
                }
            }
        });
    };

    const findSectionTotal = (chargeType, orderNo) => {
        const charges = [...(currentInvoice[chargeType] || [])];
        const elementIndex = _.findIndex(charges, { order_number: orderNo });
        if (elementIndex >= 0) {
            const priceList = chargeType === "TEMPLATE" ? 
                ikeaChargesrecord : 
                !isEmpty(charges[elementIndex].price_list) ? 
                    charges[elementIndex].price_list : [];
            const amount = findTotal(priceList, "invoice_value", 1, true);
            return amount;
        }
        return 0.0;
    };

    const handlePrintBills = async () => {
        // const selectedIds = !isEmpty(orderIds) ? orderIds : [];
        try {
            setIsSpinning(true);
            let result = await printBillingPdf(currentInvoice?.customer_order_id);
            if (result.success) {
                base64ToPdf(
                    result.bills_file,
                    `OrderBillings-${moment().format("YYYY-MM-DDTHH:mm:ss")}.pdf`
                );
            } else {
                if (result.errors.length > 0) {
                    alertMessage(result.errors.join(", "), "error", 10);
                }
            }
        } catch (error) {
            alertMessage(error.message, "error", 10);
        } finally {
            setIsSpinning(false);
        }
    };

    const getEmailSubject = async () => {
        const orderNumbers = currentInvoice?.transportation_charges.map(
            (charge) => charge.order_number
        );
        const orderIds = currentInvoice?.transportation_charges.map(
            (charge) => charge.order_id
        );
        const orderCount =
            orderNumbers.length > 1
                ? "_(" + (orderNumbers.length - 1) + "_more)"
                : "";
        const orgId = userStore.getStateValue("selectedOrg");

        const defaultSubject = orderNumbers?.length
            ? `${orderNumbers[0]} ${orderCount} ${"BILLING_PDF"}`
            : `${orderNumbers}`;

        const payload = {
            organization_id: orgId,
            order_id: orderIds[0],
            setting_name: "billing_email_subject",
        };

        try {
            const result = await getEmailSubjectLine(payload);

            if (result.success) {
                const emailSubject = result?.subject ? result.subject : defaultSubject;
                setEmailSubject(emailSubject)
            } else {
                setEmailSubject(defaultSubject)
                alertMessage(result.errors[0], "error", 10);
            }
        } catch (error) {
            console.error("Error fetching email subject:", error);
        } finally {
            setShowEmailModal(true)
            setEmailDesc("Please find the billing attachment")
        }
    };

    const getEmails = () => {
        // const account = currentInvoice?.account_details
        //     ? currentInvoice?.account_details
        //     : {};
        const accountId = account.id ? account.id : ""
        setIsEmailLoading(true)
        getContactEmails(accountId).then((result) => {
            if (result.success) {
                setEmailContacts(result.contact_emails || [])
                setIsEmailLoading(false)
            } else {
                renderAlertMessage(result.errors)
                setEmailContacts([])
                setIsEmailLoading(false)
            }
        })
    }

    const openEmailModal = () => {
        getEmailSubject();
        getEmails();
        setShowEmailModal(true)
    }

    const addBilligEmail = (value) => {
        const validEmails = validateEmailList(value);
        setBillingEmails(validEmails)
    };

    const getInvoiceOrders = () => {
        const isAdjusted = currentInvoice?.is_adjusted;

        const orders =
            currentInvoice?.transportation_charges &&
            currentInvoice.transportation_charges.length > 0
                ? currentInvoice.transportation_charges
                    .sort((a, b) => a.order_number ? a.order_number.localeCompare(b.order_number, { numeric: true }) : -1)
                    .map((order) => {
                        // Transform orders_info into locations format for each order
                        const locations = order?.locations || []
                        // currentInvoice?.orders_info?.map(info => ({
                        //     order_type: info.segment_type === "PICKUP" ? "PICKUP" : "DELIVERY",
                        //     location_id: info.id,
                        //     level_of_service_code: info.level_of_service,
                        //     location_sequence: info.segment_sequence,
                        //     appointment: {
                        //         appt_date: info.appointment_date,
                        //         start_time: info.start_time,
                        //         end_time: info.end_time
                        //     },
                        //     address: info.address
                        // })) || [];

                        // Get order type from multiple sources in priority order
                        const orderType = order.type_of_order || // First try the charge's own type
                            currentInvoice?.order_info?.type_of_order || // Then try invoice's order_info
                            (locations.length > 0 ? locations[0].order_type : ""); // Finally try first location

                        return {
                            order_id: order.order_id,
                            order_no: order.order_number,
                            is_smp_applied: order.is_smp_applied,
                            hawb: order.hawb,
                            mawb: order.mawb,
                            level_of_service: order.level_of_service,
                            driver_notes: order.driver_notes,
                            is_locked: order.is_locked,
                            smp_stamp: order.smp_stamp,
                            is_consolidated: order.is_consolidated,
                            is_driver_settlement_approved: order.is_driver_settlement_approved,
                            consolidated_id: order.consolidated_id,
                            consolidation_number: order.consolidation_number,
                            locations: locations,
                            type_of_order: orderType,
                            instructions: order.instructions || {},
                            weight: order.order_weight,
                            weight_in_kgs: order.weight_in_kgs,
                            quantity: order.order_qty,
                            surface_area: order.surface_area,
                            pallets: order.pallets,
                            related_order: order.related_order,
                            is_adjusted: isAdjusted,
                        };
                    })
                : [];
        return orders;
    };

    const handleSendingMails = () => {
        if (!billingEmails.length) return alertMessage('Please enter atleast one email address', 'error');

        const account = currentInvoice?.account_details
            ? currentInvoice?.account_details
            : {};

        let totalOrders = getInvoiceOrders();
        const selectedInfo = {
            selectedKeys: totalOrders.map((order) => order.order_id),
            selectedRows: [...totalOrders],
        };

        const payload = {
            account_id: account.id,
            customer_order_ids: [...selectedInfo.selectedKeys],
            organization_id: userStore.getStateValue('selectedOrg'),
            email_ids: billingEmails,
            subject: emailSubject,
            description: emailDesc,
        };
        setIsSendingMail(true)
        SendInvoiceEmail(payload).then((result) => {
            if (result.success) {
                alertMessage(result.message, 'success', 5);
            } else {
                alertMessage(result.message, 'error', 5);
            }
        }
        ).finally(() => { setIsSendingMail(false) }
        );
    }

    const handleInvoiceResponse = (result, id) => {
        // Get the order type from the API response
        const orderType = result.invoice?.order_info?.type_of_order;
        
        // Transform orders_info into locations format
        const transformLocations = (locations = [] , orders_info = []) => {
            return locations;
            // return orders_info.map(info => ({
            //     order_type: info.segment_type === "PICKUP" ? "PICKUP" : "DELIVERY",
            //     location_id: info.locations?.[0]?.location_id,
            //     level_of_service_code: info.level_of_service,
            //     location_sequence: info.segment_sequence,
            //     type_of_order: info.type_of_order,
            //     zone_type: info.zone_type,
            //     zone_name: info.zone_name
            // }));
        };
        
        const defaultInvoice = {
            description: {},
            account_details: {},
            customer_details: {},
            customer_order_id: id,
            remarks: _.get(result, 'remarks', []),
            consolidated_order_numbers: _.get(result, 'consolidated_order_numbers', []),
            is_driver_settlement_approved: result.is_driver_settlement_approved,
            pickup_driver_pay_details: result.pickup_driver_pay_details || {},
            accessorial_charges: [],
            adjustment_charges: [],
            transportation_charges: [],
            fuel_surcharges: [],
            order_info: {},
            status: result.billing_status,
            error_log: [],
            error_messages: [],
        };

        // Helper function to add order type to price list items
        const addOrderTypeToPriceList = (priceList = [], type_of_order) => {
            return priceList.map(item => ({
                ...item,
                type_of_order: item.type_of_order || type_of_order
            }));
        };

        // Instead of using _.merge which might override nested properties,
        // we'll manually construct the invoice object preserving the order types
        const locations = _.get(result.invoice, "transportation_charges[0].locations", []) || [];
        const invoice = {
            ...defaultInvoice,
            ...result.invoice,
            transportation_charges: result.invoice?.transportation_charges?.map(charge => ({
                ...charge,
                type_of_order: charge.type_of_order || orderType,
                locations: transformLocations(locations, result.invoice?.orders_info),
                price_list: addOrderTypeToPriceList(charge.price_list, charge.type_of_order || orderType)
            })) || [],
            fuel_surcharges: result.invoice?.fuel_surcharges?.map(charge => ({
                ...charge,
                type_of_order: charge.type_of_order || orderType,
                locations: transformLocations(locations, result.invoice?.orders_info),
                price_list: addOrderTypeToPriceList(charge.price_list, charge.type_of_order || orderType)
            })) || [],
            accessorial_charges: result.invoice?.accessorial_charges?.map(charge => ({
                ...charge,
                type_of_order: charge.type_of_order || orderType,
                locations: transformLocations(locations, result.invoice?.orders_info),
                price_list: addOrderTypeToPriceList(charge.price_list, charge.type_of_order || orderType)
            })) || [],
            adjustment_charges: result.invoice?.adjustment_charges?.map(charge => ({
                ...charge,
                type_of_order: charge.type_of_order || orderType,
                locations: transformLocations(locations, result.invoice?.orders_info),
                price_list: addOrderTypeToPriceList(charge.price_list, charge.type_of_order || orderType)
            })) || [],
            order_info: {
                ...result.invoice?.order_info,
                type_of_order: orderType
            }
        };

        const error_logs = result.error_logs || [];
        invoice.error_log = _.map(_.filter(error_logs, 'error_log'), 'error_log');
        invoice.error_messages = _.map(_.filter(error_logs, 'error_message'), 'error_message');

        return invoice;
    };

    const sortPriceList = (data) => {
        const sortedData = _.cloneDeep(data);

        // Sort accessorial charges
        sortedData.accessorial_charges.forEach(charge => {
            charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
        });

        // Sort fuel surcharges
        sortedData.fuel_surcharges.forEach(charge => {
            charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
        });

        // Sort adjustment charges
        sortedData.adjustment_charges.forEach(charge => {
            charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
        });

        return sortedData;
    };

    const getBillingDetails = (id) => {
        setIsFetchingFullDetails(true);
        fetchBillingDetails(id, props.currentOrderGroupType || "").then((result) => {
            if (result.success) {
                const invoiceStatus = result.billing_status;
                const showHoldBucket = _.get(organizationSettings, 'show_hold_bucket', '') == "true";
                
                // Pass the raw API response to handleInvoiceResponse
                let invoiceData = handleInvoiceResponse(result, id);
                
                // Ensure order type is preserved in transportation charges
                if (invoiceData.transportation_charges?.length) {
                    invoiceData.transportation_charges = invoiceData.transportation_charges.map(charge => ({
                        ...charge,
                        type_of_order: charge.type_of_order || result.invoice?.order_info?.type_of_order,
                        price_list: (charge.price_list || []).map(item => ({
                            ...item,
                            type_of_order: item.type_of_order || charge.type_of_order || result.invoice?.order_info?.type_of_order
                        }))
                    }));
                }
                
                invoiceData = sortPriceList(invoiceData);
                
                const defaultTransportationChargeGLCode = result.invoice.transportation_gl_code;
                const transportationCharges = invoiceData?.transportation_charges?.length ? 
                    invoiceData.transportation_charges[0] : [];

                setCurrentInvoice(invoiceData);
                setConsolidatedOrderNumbers(invoiceData.consolidated_order_numbers);
                setIsDriverSettlementApproved(invoiceData.is_driver_settlement_approved);
                setIsPickupByDriver(_.get(invoiceData, 'pickup_driver_pay_details.is_pickup_by_driver', "false"));
                setPickupOrderDriverId(_.get(invoiceData, 'pickup_driver_pay_details.pickup_order_driver_id', ""));
                setPickupOrderAmount(_.get(invoiceData, 'pickup_driver_pay_details.pickup_order_amount', null));
                setIsFetchingFullDetails(false);
                setShowActions(invoiceData.status === 'READY_FOR_BILLING' ? true : false);
                setIsInvoiceLocked(invoiceData?.transportation_charges && 
                    invoiceData.transportation_charges.filter(rec => rec.is_locked == 'true').length > 0 ? true : false);
                setIsOnHold(showHoldBucket ? invoiceStatus == 'HOLD' : false);
                setDefaultTransportationChargeGLCode(defaultTransportationChargeGLCode);
                setIkeaChargesrecord(transportationCharges?.price_list?.length ? transportationCharges.price_list : []);

                if (Object.keys(rawInvoice).length === 0) {
                    setRawInvoice(invoiceData);
                    getDrivers();
                    getCompleteDrivers();
                    getAccessorials();
                    getAccountLos();
                    setAccountLos();
                    getAccountConfigs();
                    getOrgLogo();
                    setInvoiceLosFunc();
                    setSelectedInfoFunc();
                    getTechnicians();
                } else {
                    setInvoiceLosFunc();
                }
            } else {
                renderAlertMessage(result.errors);
                setCurrentInvoice({});
                setIsFetchingFullDetails(false);
            }
        });
    };

    const goToTab = (key) => {
        setActiveKey(key)
        if (key === 'activities') {
            invoiceActivities();
        }
    }

    const invoiceActivities = () => {
        setIsSpinning(true)
        setFilteredOrdersForActivities(currentInvoice.transportation_charges.map((orders) => orders.order_number))
        setFilterOrderIds(currentInvoice.transportation_charges)
        const params = {
            organization_id: userStore.getStateValue("selectedOrg"),
            customer_order_ids: currentInvoice.transportation_charges.map((orderIds) => orderIds.order_id)
        }
        getBillingActivities(params).then(result => {
            if (result.success) {
                // this.setState({ billingActivitiesList: result.data.activities, filteredBillingActivitiesList: result.data.activities, })
                setBillingActivitiesList(result.data.activities)
                setFilteredBillingActivitiesList(result.data.activities)
            }
            else {
                renderAlertMessage(result.errors);
            }
        }
        ).finally(() => {
            setIsSpinning(false)
        })
    }

    const getDrivers = () => {
        // this.setState({ isFetchingDrivers: false });
        fetchUsers("driver", 1, null, true).then((result) => {
            if (result.success) {
                setDrivers(result.users)
            } else if (result.errors) {
                renderAlertMessage(result.errors);
            }
        });
    };

    const getCompleteDrivers = () => {
        setIsSpinning(true)
        fetchUsers("driver").then((result) => {
            if (result.success) {
                const updatedDrivers = result.users.map((driver) => ({
                    id: driver.id,
                    employee_code: driver.employee_code,
                    full_name: driver.full_name,
                }));
                setDriversList(updatedDrivers)
            } else {
                renderAlertMessage(result.errors)
            }
        }).catch((error) => {
            alertMessage(error.message, "error", 10)
        }).finally(() => {
            setIsSpinning(false)
        });
    };

    const getAccessorials = () => {
        // const account = currentInvoice?.account_details
        //     ? currentInvoice?.account_details
        //     : {};
        fetchAccountAccessorials(account.id, "ALL").then((result) => {
            if (result.success) {
                setAccessorials(result.accessorials)
            } else {
                renderAlertMessage(result.errors)
                // this.setState({ inProgress: false });
            }
        });
    };

    const getAccountLos = async () => {
        // const accountObj = currentInvoice?.account_details || {};
        const accountCode = account.account_code || '';
        const accountId = account.id || '';
        const currentOrgId = userContext?.currentOrg?.id || '';
        try {
            const [losResponse, configResponse] = await Promise.all([
                fetchAccountShortLos(accountCode),
                fetchOrderTypeLos(currentOrgId, accountId),
            ]);
            const losConfig = configResponse?.success ?
                configResponse.data.los.reduce((acc, rec) => {
                    acc[rec.order_type] = rec.los_codes ? [...rec.los_codes, 'NONE'] : ['NONE'];
                    return acc;
                }, {}) : {};

            if (losResponse.success) {
                const levelOfServices = losResponse.account.account_los || [];
                setLosConfig(losConfig)
                setLevelOfServices([
                    ...levelOfServices,
                    {
                        name: 'None',
                        code: 'NONE',
                        duration: '0',
                        id: 'NONE',
                    },
                ])
            } else {
                renderAlertMessage(losResponse.errors);
                setLosConfig(losConfig);
            }
        } catch (error) {
            console.error(`Error fetching ${I18n.t("general.short_los")}:`, error);
            setLosConfig({});
        }
    };

    const getAccountConfigs = () => {
        // const { config, invoice } = this.state;
        let config = {}
        fetchAccountConfigs(
            account?.id,
            userStore.getStateValue("selectedOrg"),
            "ALL"
        ).then((result) => {
            if (result.success) {
                const accountConfigurations = result.account_configurations || [];
                accountConfigurations.forEach((setting) => {
                    config[setting.setting_name] = setting.setting_value;
                });
                if (
                    !isEmpty(config.pod_pic_settings) &&
                    _.isString(config.pod_pic_settings) &&
                    config.pod_pic_settings === "[]"
                ) {
                    config.pod_pic_settings = [];
                }
                config.pod_pic_settings = updatePicSettingsWithBol(
                    config.pod_pic_settings
                );
                if (isEmpty(config.communication_preference)) {
                    config.communication_preference = "SMSES";
                }
                setConfig(config)
            } else {
                renderAlertMessage(result.errors)
            }
        });
    };

    const getTechnicians = () => {
        fetchTechnicians().then((result) => {
            if (result.success) {
                const technicians = result.users || [];
                setTechnicians(technicians)
            } else {
                setTechnicians([])
            }
        });
    };

    const setAccountLos = () => {
        const los =
            currentInvoice?.order_info &&
                currentInvoice?.order_info.level_of_service
                ? currentInvoice?.order_info.level_of_service
                : "";
        handleStateOnChange("currentLos", los);
    };

    const setInvoiceLosFunc = () => {
        const invoiceLos = {};
        const totalOrders = getInvoiceOrders();
        totalOrders.forEach((order) => {
            invoiceLos[order.order_id] = [];
            //invoiceLos[order.order_id] = order.level_of_service;
            order?.locations.forEach(loc => {
                invoiceLos[order.order_id].push({
                    location_id: loc.location_id,
                    level_of_service_code: loc.level_of_service_code,
                });
            })

        });
        setInvoiceLos(invoiceLos)
    };

    const setSelectedInfoFunc = () => {
        let totalOrders = getInvoiceOrders();
        const selectedInfo = {
            selectedKeys: totalOrders.map((order) => order.order_id),
            selectedRows: [...totalOrders],
        };
        // this.setState({ selectedInfo });
        setSelectedInfo(selectedInfo)
    }

    const handleStateOnChange = (element, value, isLosChanged = false) => {
        if (currentInvoice?.status == "APPROVED") {
            if (element == "invoiceLos" && isLosChanged) { //&& val !== retrivedLos)
                props.handleIsLosChanged(true);
            } else {
                props.handleIsLosChanged(false);
            }
        }
        if (element === "invoiceLos") {
            setInvoiceLos(value)
            if (currentInvoice?.status !== "APPROVED") {
                reGenerate();
            }

        }
        else if (element === "currentLos") {
            setCurrentLos(value)
        }
        else {
            // this.setState({
            //     [element]: value,
            // });
        }
    };

    const reGenerate = () => {
        props.handleIsLosChanged(false);
        regenerateInvoiceWithLos(invoiceLos, handleSaveAndReapprove);
        // this.getBillingDetails(this.state.invoice.customer_order_id)
    };

    const regenerateInvoiceWithLos = (invoiceLos, cb = null) => {
        setIsSpinning(true)
        const data = {
            organization_id: userStore.getStateValue("selectedOrg"),
            fmp_order_id: getFMPOrderFromInvoice(currentInvoice),
            account_id: currentInvoice?.account_details?.id,
            orders_info: Object.keys(invoiceLos).map((rec) => {
                const nonNoneLos = _.get(_.find(invoiceLos[rec], function (o) { return o.level_of_service_code !== 'NONE' }), "level_of_service_code", "") || "";
                return ({
                    customer_order_id: rec,
                    los_code: nonNoneLos || _.get(invoiceLos[rec], "[0].level_of_service_code", "") || "",
                    locations_info: invoiceLos[rec],

                })
            }),
        };
        message.loading({
            key: "generate",
            content: I18n.t("messages.generating"),
        });
        regenerateInvoiceWithNewLos(data)
            .then((result) => {
                if (result.success) {
                    message.success({
                        key: "generate",
                        content: I18n.t("messages.generated"),
                    });
                    const invoice = handleInvoiceResponse(
                        result,
                        currentInvoice.customer_order_id
                    );
                    setCurrentInvoice(invoice);
                    () => {
                        getBillingDetails(currentInvoice.customer_order_id)
                        if (currentInvoice?.status === "APPROVED") {
                            cb();
                        }
                    }
                } else {
                    message.error({
                        key: "generate",
                        content: result.errors.join(","),
                    });
                }
            })
            .finally(() => {
                setIsSpinning(false)
            });
    };

    const handleSaveAndReapprove = async (selectedInfo = selectedInfo ? selectedInfo : selectedInfo) => {
        // this.setState({ isRepproveLoading: true });
        setIsApproving(true)
        const selectedIds = [order.id]
        try {
            const payload = {
                customer_order_ids: selectedIds,
                organization_id: userStore.getStateValue("selectedOrg"),
                invoice_number: currentInvoice.order_number
            };
            if (isPickupByDriver === "true") {
                payload.is_pickup_by_driver = "true";
                payload.pickup_order_driver_id = pickupOrderDriverId;
                payload.pickup_order_amount = pickupOrderAmount;
            }
            let response = {};
            response = await reapproveBillings(payload);
            if (response.success) {
                const result = response?.invoices ? response.invoices : {};
                const successMessage = result?.message
                    ? result.message
                    : I18n.t("messages.saved");
                //  typeof onSave === 'function' && onSave(I18n.t('messages.saved'))
                alertMessage(successMessage);
                handleApproveSuccess("APPROVED")
                // resetValues();
            } else {
                throw new Error(response.errors[0]);
            }
        } catch (error) {
            alertMessage(error.message, "error", 10);
        } finally {
            //   this.setState({ isRepproveLoading: false });
            setIsApproving(false)
        }
    };

    const handleApproveSuccess = (status) => {
        // setIsApproved(true);
        // setLoading(false);
        setCurrentInvoice((prevInvoice) => ({
            ...prevInvoice,
            status,
        }));
        // setEnableHide(true);
    };

    const searchBar = (e) => {
        const value = e.target.value
        const billingActivities = billingActivitiesList;
    
        if (!_.isEmpty(_.trim(value))) {
          const lowerValue = _.lowerCase(_.trim(value));
          const filteredActivities = billingActivities.filter(item => {
            const activityValues = Object.values(item);
            return activityValues.some(val => _.lowerCase(val).includes(lowerValue));
          });
    
        setFilteredBillingActivitiesList(filteredActivities)
        } else {
            setFilteredBillingActivitiesList(billingActivities)
        }
      }

    const filterOrderNos = (selectedTags) => {
        // const { filterOrderIds } = this.state;
        const updatedTags = selectedTags;
        const orderIds = [];
        if (selectedTags.length === 0 && filteredOrdersForActivities.length === 1) {
          return;
        }
        // Iterate over each tag in updatedTags
        updatedTags.forEach(tag => {
          // Find the corresponding object in filterOrderIds
          const matchingOrder = filterOrderIds.find(order => order.order_number === tag);
    
          // If a matching object is found, push its orderId into the orderIds array
          if (matchingOrder) {
            orderIds.push(matchingOrder.order_id);
          }
        });
        setFilteredOrdersForActivities(updatedTags)
          const parms = {
            organization_id: userStore.getStateValue("selectedOrg"),
            customer_order_ids: orderIds
          };
          getBillingActivities(parms).then(result => {
            if (result.success) {
            setBillingActivitiesList(result.data.activities)
            setFilteredBillingActivitiesList(result.data.activities)
            }
            else {
              renderAlertMessage(result.errors);
            }
          })
      }

    const handleUpdateInvoice = (updatedInvoice, orderNo) => {
        setCurrentInvoice(prevState => {
          // Update the state with new invoice data
          const updatedOrderDriverDetails = prevState.order_driver_details.map(order => {
            if (order.customer_order_id === orderNo) {
              return {
                ...order,
                driver_details: updatedInvoice.order_driver_details.find(o => o.customer_order_id === orderNo)?.driver_details || [],
              };
            }
            return order;
          });

          return {
            ...prevState,
            order_driver_details: updatedOrderDriverDetails,
          };
        });
      };

    const handleAddItem = (chargeType, orderNo, locations) => {
        // Get current charges array or initialize it
        let charges = [...(currentInvoice[chargeType] || [])];
        
        // Always use the first location as default if available
        const defaultLocation = locations?.[0];
        
        // Create the new item data with all required fields
        const data = {
            invoice_name: "",
            invoice_value: "0",
            invoice_quantity: 1,
            isNew: true,
            invoice_type: chargeType === "accessorial_charges" ? "Accessorial" : I18n.t(`invoices.invoice_types.${chargeType}`),
            location_id: defaultLocation?.location_id || "",
            location_type: defaultLocation?.order_type || "",
            type_of_order: currentInvoice?.order_info?.type_of_order,
            item_per_cost: "0",
            item_description: "",
            added_from: "MANUAL",
            order_item_weight: null,
            is_fmp_applied: "false",
            driver_pay_params: [],
            component_params: [],
            gl_code: chargeType === "fuel_surcharges" ? config["fuel_surcharge_gl_code"] : "",
            unit_price: chargeType === "transportation_charges" ? 0.0 : undefined,
            temp_id: `new_${Date.now()}`
        };

        // Find existing charge or add new one
        const index = _.findIndex(charges, { order_number: orderNo });
        if (index >= 0) {
            if (!charges[index].price_list) {
                charges[index].price_list = [];
            }
            charges[index].price_list.push(data);
        } else {
            charges.push({
                order_id: order?.id,
                order_number: orderNo,
                level_of_service: currentInvoice?.order_info?.level_of_service,
                is_locked: "false",
                type_of_order: currentInvoice?.order_info?.type_of_order,
                locations: locations.map(loc => ({
                    order_type: loc.order_type,
                    location_id: loc.location_id,
                    level_of_service_code: loc.level_of_service_code,
                    type_of_order: loc.type_of_order,
                    zone_type: loc.zone_type,
                    zone_name: loc.zone_name
                })),
                price_list: [data]
            });
        }

        // Update the invoice state
        setCurrentInvoice(prev => ({
            ...prev,
            [chargeType]: charges
        }));

        // Update ikeaChargesrecord if needed
        if (chargeType === "transportation_charges" && ikeaChargesrecord) {
            const updatedRecords = [...ikeaChargesrecord];
            updatedRecords.push(data);
            handleUpdateRecords(updatedRecords);
        }
    };

    const handleItemsChange = (index, element, value, chargeType, orderNo) => {
        // Safely get the charges array, defaulting to empty array if undefined
        const charges = [...(currentInvoice[chargeType] || [])];
        if (!Array.isArray(charges)) return;

        const elementIndex = _.findIndex(charges, { order_number: orderNo });
        if (elementIndex >= 0) {
            const updatedCharges = [...charges];
            
            // Initialize price_list if it doesn't exist
            if (!updatedCharges[elementIndex].price_list) {
                updatedCharges[elementIndex].price_list = [];
            }
            
            // Ensure we have an array to work with
            const priceList = Array.isArray(updatedCharges[elementIndex].price_list) ? 
                [...updatedCharges[elementIndex].price_list] : [];
            
            // For new items, ensure the item exists at the specified index
            if (!priceList[index]) {
                priceList[index] = {
                    invoice_name: "",
                    invoice_value: "0",
                    invoice_quantity: 1,
                    isNew: true,
                    invoice_type: chargeType === "accessorial_charges" ? "Accessorial" : I18n.t(`invoices.invoice_types.${chargeType}`),
                    location_id: "",
                    type_of_order: updatedCharges[elementIndex].type_of_order || currentInvoice?.order_info?.type_of_order,
                    item_per_cost: "0",
                    item_description: "",
                    added_from: "MANUAL",
                    order_item_weight: null,
                    is_fmp_applied: "false",
                    driver_pay_params: [],
                    component_params: [],
                    gl_code: chargeType === "fuel_surcharges" ? config["fuel_surcharge_gl_code"] : "",
                    unit_price: chargeType === "transportation_charges" ? 0.0 : undefined,
                    temp_id: `new_${Date.now()}`
                };
            } else if (element === "accessorial_code" && !isEmpty(value)) {
                const currentAccRecord = _.find(accessorials, {
                    accessorial_code: value,
                });
                if (!isEmpty(currentAccRecord)) {
                    priceList[index]["gl_code"] =
                    currentAccRecord.gl_code;
                }
                  
            }

            // Update the value, ensuring numeric values are properly handled
            let updatedValue = value;
            if (element === 'invoice_value') {
                updatedValue = isNaN(parseFloat(value)) ? "0" : value.toString();
            } else if (element === 'invoice_quantity') {
                // Ensure invoice_quantity is handled as a number and defaults to 1 if invalid
                updatedValue = isNaN(parseInt(value)) || parseInt(value) <= 0 ? "1" : value.toString();
            }

            priceList[index] = {
                ...priceList[index],
                [element]: updatedValue
            };

            // Update the charges array
            updatedCharges[elementIndex] = {
                ...updatedCharges[elementIndex],
                price_list: priceList
            };

            // Update the invoice state
            setCurrentInvoice(prev => {
                const newState = {
                    ...prev,
                    [chargeType]: updatedCharges
                };
                
                // Calculate grand total across all charge types
                let grandTotal = 0;
                ["transportation_charges", "fuel_surcharges", "accessorial_charges", "adjustment_charges"].forEach(type => {
                    const typeCharges = type === chargeType ? updatedCharges : prev[type] || [];
                    typeCharges.forEach(charge => {
                        if (charge.price_list && Array.isArray(charge.price_list)) {
                            charge.price_list.forEach(item => {
                                const itemValue = parseFloat(item.invoice_value) || 0;
                                const itemQuantity = parseInt(item.invoice_quantity) || 1;
                                grandTotal += itemValue * itemQuantity;
                            });
                        }
                    });
                });
                
                // Ensure the total is a valid number
                newState.total_amount = isNaN(grandTotal) ? 0 : parseFloat(grandTotal.toFixed(2));
                
                return newState;
            });

            // Update ikeaChargesrecord if needed
            if (chargeType === "transportation_charges" && ikeaChargesrecord) {
                const updatedRecords = [...ikeaChargesrecord];
                if (updatedRecords[index]) {
                    updatedRecords[index] = {
                        ...updatedRecords[index],
                        [element]: updatedValue
                    };
                }
                handleUpdateRecords(updatedRecords);
            }
        }
    };

    const handleDeleteClick = (recordNO, chargeType, orderNo) => {
        const charges = [...currentInvoice[chargeType]];
        const elementIndex = _.findIndex(charges, { order_number: orderNo });
        if (elementIndex >= 0) {
            const currentItem = charges[elementIndex].price_list[recordNO];
            
            if (currentItem?.id) {
                setIsSpinning(true);
                deleteInvoiceLine(currentItem.id)
                    .then((result) => {
                        if (result.success) {
                            alertMessage(I18n.t("messages.deleted"));
                            
                            // Update UI state after successful deletion
                            charges[elementIndex].price_list.splice(recordNO, 1);
                            setCurrentInvoice(prev => ({
                                ...prev,
                                [chargeType]: charges
                            }));
                            
                            // Refresh billing details if needed
                            if (currentInvoice.status === "APPROVED") {
                                handleSaveAndReapprove();
                            }
                            getBillingDetails(currentInvoice.customer_order_id);
                        } else {
                            alertMessage(result.errors, "error", 10);
                        }
                    })
                    .finally(() => {
                        setIsSpinning(false);
                    });
            } else {
                // For new items that haven't been saved yet, just update the UI
                charges[elementIndex].price_list.splice(recordNO, 1);
                setCurrentInvoice(prev => ({
                    ...prev,
                    [chargeType]: charges
                }));
            }
        }
    };

    const handleSaveItem = (index, itemType, orderNo) => {
        const charges = [...currentInvoice[itemType]];
        const elementIndex = _.findIndex(charges, { order_number: orderNo });
        if (elementIndex >= 0) {
            const typeObject = currentInvoice[itemType][elementIndex] || {};
            const priceList = typeObject.price_list || [];
            const item = priceList[index];
            
            let newInvoiceLines = [];
            // Separate new and edited items
            const newItems = priceList.filter((line) => line.isNew === true);
            const editedItems = priceList.filter((line) => line.isEditing === true);

            if (itemType === "accessorial_charges") {
                [...newItems, ...editedItems].forEach((line) => {
                    const newLine = Object.assign({}, line);
                    const accessorialIndex = _.findIndex(accessorials, [
                        "accessorial_code",
                        line.accessorial_code,
                    ]);
                    if (accessorialIndex >= 0) {
                        newLine.invoice_name = accessorials[accessorialIndex].accessorial_name;
                        newLine.account_accessorial_id = accessorials[accessorialIndex].id;
                    }
                    newLine.invoice_type = "Accessorial";
                    newInvoiceLines.push(newLine);
                });
            } else {
                newInvoiceLines = [...newItems, ...editedItems].map(line => ({
                    ...line,
                    invoice_type: I18n.t(`invoices.invoice_types.${itemType}`)
                }));
            }

            // Then make the API call
            setIsSpinning(true);

            // Determine if we're editing an existing line or creating a new one
            const isEditing = item.id && item.isEditing;
            const data = {
                new_invoice_lines: newInvoiceLines,
                remark: "",
                order_group_type: currentInvoice.order_group_type,
                customer_order_id: typeObject.order_id || currentInvoice.order_info.order_id || "",
                reference_id: currentInvoice.order_group_type === "ORDER" ? 
                    currentInvoice.customer_order_id : 
                    currentInvoice.order_number,
                status: currentInvoice.status,
                organization_id: userStore.getStateValue("selectedOrg"),
                account_id: account?.id,
                order_id: order?.id,
                invoice_type: itemType
            };

            // Add invoice_line_id for editing existing lines
            if (isEditing) {
                data.invoice_line_id = item.id;
            }

            // Use the appropriate API based on whether we're editing or creating
            const apiCall = isEditing ? updateInvoiceCharges : updateInvoiceLines;
            
            apiCall(data)
                .then((result) => {
                    if (result.success) {
                        alertMessage(I18n.t("messages.saved"));
                        
                        // Always refresh billing details after successful save
                        getBillingDetails(currentInvoice.customer_order_id);
                        if (refreshDetails) {
                            refreshDetails();
                        }                        
                        // If it's an approved invoice, handle reapproval
                        if (currentInvoice?.status === "APPROVED") {
                            handleSaveAndReapprove();
                        }
                    } else {
                        alertMessage(result.errors, "error", 10);
                        if (!isEditing) {
                            handleDeleteClick(index, itemType, orderNo);
                        }
                    }
                })
                .finally(() => {
                    setIsSpinning(false);
                });
        }
    };

    const handleInputSaveItem = (recordNO, itemType, orderNo) => {
        handleSaveItem(recordNO, itemType, orderNo);
    };

    const handleEditItem = (index, itemType, itemId, record) => {
        if (record && record.isEditing) {
            const updatedOrder = _.cloneDeep(currentInvoice);
            const priceListIndex = _.findIndex(updatedOrder[itemType], (item) =>
                item.price_list.find((line) => line.id === itemId)
            );
            if (priceListIndex >= 0) {
                const priceListToEdit = updatedOrder[itemType][priceListIndex];
                const priceList = priceListToEdit.price_list || [];
                const updatedPriceList = priceList.map((item, i) =>
                    i === index ? { ...item, isEditing: true } : { ...item, isEditing: false }
                );

                updatedOrder[itemType][priceListIndex].price_list = updatedPriceList;
                setCurrentInvoice(updatedOrder);
            }
        }
    };

    const cancelEditItem = (index, itemType, itemId) => {
        const updatedOrder = _.cloneDeep(currentInvoice);
        const previousOrder = _.cloneDeep(rawInvoice);
        
        const priceListIndex = _.findIndex(updatedOrder[itemType], (item) =>
            item.price_list.find((line) => line.id === itemId)
        );
        
        if (priceListIndex >= 0) {
            const priceList = updatedOrder[itemType][priceListIndex].price_list || [];
            const previousPriceList = previousOrder[itemType][priceListIndex]?.price_list || [];
            
            const updatedPriceList = priceList.map((item) => {
                if (item.id === itemId) {
                    const originalItem = previousPriceList.find(
                        (prevItem) => prevItem.id === itemId
                    );
                    return {
                        ...(originalItem || item),
                        isEditing: false
                    };
                }
                return item;
            });
            
            updatedOrder[itemType][priceListIndex].price_list = updatedPriceList;
            setCurrentInvoice(updatedOrder);
        }
    };

    const editSave = (index, itemType, orderNo, id) => {
        const updatedOrder = _.cloneDeep(currentInvoice);
        const charges = updatedOrder[itemType];
        const elementIndex = _.findIndex(charges, { order_number: orderNo });
        
        if (elementIndex >= 0 && charges[elementIndex]?.price_list) {
            const priceList = charges[elementIndex].price_list;
            const itemIndex = _.findIndex(priceList, { id });
            
            if (itemIndex >= 0) {
                // Call handleSaveItem to save changes to backend
                // Only update UI state after successful save
                handleSaveItem(itemIndex, itemType, orderNo);
            }
        }
    };

    const handleUpdateRecords = (updatedRecords) => {
        setIkeaChargesrecord(updatedRecords);
      };

    const renderEmailModal = () => {
        const description = "Description" // I18n.t("general.body")
        const subject = "Subject" // I18n.t("general.subject")
        return (
            <BaseModal
                title={I18n.t("general.send_to", { from: I18n.t("invoices.billing"), to: "Emails" })}
                // onCancel={() => this.setState({
                //   showEmailModal: false,
                //   billingEmails: []
                // })}
                onCancel={() => {
                    setShowEmailModal(false)
                    setBillingEmails([])
                }}
                width="75%"
                style={{ top: 40 }}
                maskClosable={false}
            >
                <Spin spinning={isEmailLoading}>
                    <Row className="tagsInput emailForm" type='flex' align='middle' gutter={8}>
                        <Col span={21}>
                            {/* <FormItem label= {I18n.t('general.email')} require>
                  <EmailsInput emails={ this.state.billingEmails } onChange={ this.addBilligEmail } />
                </FormItem> */}
                            <FormItem label={I18n.t('general.email')}>
                                <Select
                                    value={billingEmails}
                                    onChange={addBilligEmail}
                                    mode="tags"
                                    validationRegex={addBilligEmail}
                                    style={{ width: "100%" }}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    placeholder="Enter or select Emails"
                                    tokenSeparators={","}
                                >
                                    {
                                        emailContacts.map(opt => <Select.Option key={opt}>{opt}</Select.Option>)
                                    }
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span={3} className="alignRight" style={{ marginTop: "8px" }}>
                            <Button_v2 className={"raised small-btn"} loading={isSendingMail} icon='mail' onClick={() => handleSendingMails()}>
                                Send
                            </Button_v2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormItem label={subject}>
                                <Input
                                    rows={4}
                                    placeholder={subject}
                                    className="sop-form-textArea"
                                    value={emailSubject}
                                    onChange={(e) => setEmailSubject(e.target.value)}
                                />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormItem label={description}>
                                <TextArea
                                    rows={4}
                                    placeholder={description}
                                    className="sop-form-textArea"
                                    value={emailDesc}
                                    onChange={(e) => setEmailDesc(e.target.value)}
                                />
                            </FormItem>
                        </Col>
                    </Row>
                </Spin>

            </BaseModal>
        );
    }

    // const transformedLocations = currentInvoice?.orders_info?.map(info => ({
    //     order_type: info.segment_type === "PICKUP" ? "PICKUP" : "DELIVERY",
    //     location_id: info.locations?.[0]?.location_id,
    //     level_of_service_code: info.level_of_service,
    //     location_sequence: info.segment_type === "PICKUP" ? 0 : 1
    // })) || [];

    const orderDataWithLocations = {
        ...order,
        locations: order.locations.map(loc => { 
            return {
                order_type: loc.type_of_loc === "PICKUP" ? "PICKUP" : "DELIVERY",
                level_of_service_code: loc?.los_code,
                location_sequence: loc.loc_order_sequence,
                location_id: loc.id,
            };  
        }),
        type_of_order: currentInvoice?.order_info?.type_of_order
    };

      const  useJobTotal = (currentInvoice, order, decimalPoints) =>  {
        return useMemo(() => {
          const totalList = _.compact([
            ...(currentInvoice?.transportation_charges || []),
            ...(currentInvoice?.fuel_surcharges || []),
            ...(currentInvoice?.accessorial_charges || []),
            ...(currentInvoice?.adjustment_charges || []),
          ]) || [];
      
          const orderCharges = totalList.filter(
            (items) => items.order_id === order?.id
          );
      
          const totalPriceList = _.flattenDeep(
            _.compact(orderCharges.map((item) => [...item.price_list]))
          );
      
          return findNumberTotal(
            totalPriceList,
            "invoice_value",
            null,
            decimalPoints
          );
        }, [currentInvoice, order?.id, decimalPoints]);
      }

    return (
        <>
            <Row className="drawer-header" type="flex" align="middle" justify='space-between'>
                <Col>
                    <Row type="flex" align="middle" gutter={16}>
                        <Col>
                            <img src={IconClose} onClick={() => closeDrawer()} style={{ cursor: "pointer" }} />
                        </Col>
                        <Col className="drawer-header-title">
                             {order?.customer_order_details?.invoice_number ?  `Invoice #${order?.customer_order_details?.invoice_number}` :
                              order?.customer_order_details?.customer_order_number ? `Billing #${order?.customer_order_details?.customer_order_number}` : ""}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row gutter={16} type="flex">
                        <Button_v2
                            className="small-btn flat"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                            onClick={() => handlePrintBills()}
                        >
                            <PrintIcon height="16" width="16" color="#617AD6" />
                            Print
                        </Button_v2>
                        <Button_v2
                            className="small-btn flat"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                            onClick={() => openEmailModal()}
                        >
                            <EmailIcon height="16" width="16" color="#617AD6" />
                            Email
                        </Button_v2>
                        {/* <Button_v2
                            className="small-btn flat"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                        >
                            <EditPennIcon height="16" width="16" color="#617AD6" />
                            Edit
                        </Button_v2> */}
                    </Row>
                </Col>
            </Row>
            <Spin spinning={isSpinning || isApproving || isFetchingFullDetails}>
                <Tabs defaultActiveKey="details" className="invoice-details-tabs" activeKey={activeKey} onChange={goToTab} >
                    <TabPane tab="Details" key="details">
                        <div className="invoice-details-body">
                            <div className="invoice-details-box">
                                <Row gutter={8} type="flex" justify='space-between' align='bottom'>
                                    <Col span={12}>
                                        <img src={orgLogo} alt="Company Logo" height="32px" width="108px" />
                                        <div className="company-details">{currentInvoice?.organization_name}</div>
                                    </Col>
                                    <Col span={12}>
                                        <Row gutter={8} type="flex" justify='end'>
                                            <Col span={12} className="alignRight">
                                                <div className="invoice-details-head">Total Due</div>
                                                <div className="invoice-due">{checkNegitive(currentInvoice?.total_amount)}</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="account-details-row" type="flex" justify='space-between'>
                                    {currentInvoice?.account_details?.name && (
                                        <Col>
                                            <div className="account-heading">Account</div>
                                            <div className="account-details">{currentInvoice?.account_details?.name}, {currentInvoice?.account_details?.code}</div>
                                        </Col>
                                    )}
                                    <Col className="alignRight">
                                        <div className="account-heading">Date</div>
                                        <div className="date-details">{moment().format("MMM D, YYYY")}</div>
                                    </Col>
                                </Row>
                                {!_.isEmpty(currentInvoice?.orders_info) && (
                                    <Row className="address-info-row">
                                        <Col md={24} className="address-info-rows">
                                            {currentInvoice?.orders_info?.length ? (
                                                currentInvoice?.orders_info.map((zone, index) => (
                                                    <div>
                                                        <Row gutter={8} type="flex">
                                                            <Col className="address-location-details">
                                                                {zone.segment_type === "PICKUP" ? getOrderTypeIcon("R", { height: "16", width: "16" }) : getOrderTypeIcon("D", { height: "16", width: "16" })}
                                                                <div>{zone.segment_type} Address: </div>
                                                            </Col>
                                                            {/* <Col className="address-location-details"><AddressInfo address={locations[index].address} /></Col> */}
                                                            <Col className="address-location-details blue-text">
                                                                {zone.segment_type === "PICKUP" ? <AddressInfo address={currentInvoice.pickup_address.address} /> : <AddressInfo address={currentInvoice.delivery_address.address} />}
                                                            </Col>
                                                        </Row>
                                                        <Row key={index} className="order-info-row" type="flex" gutter={16}>
                                                            {/* <Col>
                                                                <Row type="flex" gutter={4}>
                                                                    <Col className="zone-details-heading">Date:</Col>
                                                                    <Col className="zone-details-desc">{`${locations[index].appointment.appt_date} ${locations[index].appointment.start_time}-${locations[index].appointment.end_time}`}</Col>
                                                                </Row>
                                                            </Col> */}
                                                            <Col className="zone-details-col">
                                                                <Row type="flex" gutter={4}>
                                                                    <Col className="zone-details-heading">Zone:</Col>
                                                                    <Col className="zone-details-desc">{zone.zone_name || "NA"}</Col>
                                                                </Row>
                                                            </Col>
                                                            <Col className="zone-details-col">
                                                                <Row type="flex" gutter={4}>
                                                                    <Col className="zone-details-heading">Type:</Col>
                                                                    <Col className="zone-details-desc">{zone.zone_type || "NA"}</Col>
                                                                </Row>
                                                            </Col>
                                                            {zone.zone_type === "location" && (
                                                                <>
                                                                    <Col className="zone-details-col">
                                                                        <Row type="flex" gutter={4}>
                                                                            <Col className="zone-details-heading">{I18n.t("general.zipcode")}:</Col>
                                                                            <Col className="zone-details-desc">{zone.zipcode || "NA"}</Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col className="zone-details-col">
                                                                        <Row type="flex" gutter={4}>
                                                                            <Col className="zone-details-heading">{I18n.t("general.distance")}:</Col>
                                                                            <Col className="zone-details-desc">
                                                                                {!isEmpty(zone.distance) ?
                                                                                    `${parseFloat(zone.distance)} ${AppConfig.distance_unit}` :
                                                                                    "NA"
                                                                                }
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </>
                                                            )}
                                                            {zone.zone_type === "distance" && (
                                                                <Col className="zone-details-col">
                                                                    <Row>
                                                                        <Col md={24}>
                                                                            <div className="">
                                                                                <span className="zone-details-heading">
                                                                                    {I18n.t("general.distance")}:
                                                                                </span>
                                                                                <span className="zone-details-desc">
                                                                                    {" "}
                                                                                    {!isEmpty(zone.distance)
                                                                                        ? `${parseFloat(zone.distance)} ${AppConfig.distance_unit
                                                                                        }`
                                                                                        : "NA"}
                                                                                </span>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            )}
                                                            <Col>
                                                                <Row type="flex" gutter={4}>
                                                                    <Col className="zone-details-heading">{I18n.t("general.short_los")}:</Col>
                                                                    <Col className="zone-details-desc">{zone.level_of_service}</Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                ))
                                            ) : (
                                                <Fragment />
                                            )}
                                        </Col>
                                    </Row>
                                )}
                                <Row className="order-number-details">Order #{currentInvoice?.order_info?.order_number}</Row>
                                <Row className="charges-table-view">
                                    <ChargesSection
                                        title={I18n.t("invoices.charges")}
                                        chargeType="transportation_charges"
                                        section={currentInvoice?.transportation_charges?.[0] || {}}
                                        //locations={currentInvoice?.orders_info || []}
                                        //locations={currentInvoice?.order_info?.locations || []}
                                        locations={orderDataWithLocations?.locations || []}
                                        isTemplateZoneBilling={currentInvoice?.order_group_type === "TEMPLATE"}
                                        isInvoiceLocked={isInvoiceLocked}
                                        isReadyOnly={false}
                                        showActions={showActions}
                                        isOnHold={isOnHold}
                                        isAdjusted={false}
                                        handleAddItem={handleAddItem}
                                        handleItemsChange={(index, element, value, orderNo) =>
                                            handleItemsChange(index, element, value, "transportation_charges", orderNo)
                                        }
                                        handleDeleteClick={handleDeleteClick}
                                        handleInputSaveItem={handleInputSaveItem}
                                        findSectionTotal={findSectionTotal}
                                        orderData={orderDataWithLocations}
                                        glCodesList={orgData.glCodesList}
                                        handleEditItem={handleEditItem}
                                        cancelEditItem={cancelEditItem}
                                        editSave={editSave}
                                        removeEditingVals={false}
                                        ikeaChargesrecord={ikeaChargesrecord}
                                        updateRecords={handleUpdateRecords}
                                        defaultTransportationChargeGLCode={defaultTransportationChargeGLCode}
                                        isInvoiceApproved={currentInvoice?.status === "APPROVED"}
                                        refreshParentDetails={() => getBillingDetails(currentInvoice?.customer_order_id)}
                                        refreshAccessorial={getAccessorials}
                                        screenType={"InvoiceDetailsDrawer"}
                                    />
                                </Row>
                                <Row className="charges-table-view">
                                    <ChargesSection
                                        title={I18n.t("invoice_lines.fuel_surcharges")}
                                        chargeType="fuel_surcharges"
                                        section={currentInvoice?.fuel_surcharges?.[0] || {}}
                                        //locations={currentInvoice?.orders_info || []}
                                        //locations={currentInvoice?.order_info?.locations || []}
                                        locations={orderDataWithLocations?.locations || []}
                                        isTemplateZoneBilling={false}
                                        isInvoiceLocked={isInvoiceLocked}
                                        isReadyOnly={false}
                                        showActions={showActions}
                                        isOnHold={isOnHold}
                                        isAdjusted={false}
                                        handleAddItem={handleAddItem}
                                        handleItemsChange={(index, element, value, orderNo) =>
                                            handleItemsChange(index, element, value, "fuel_surcharges", orderNo)
                                        }
                                        handleDeleteClick={handleDeleteClick}
                                        handleInputSaveItem={handleInputSaveItem}
                                        findSectionTotal={findSectionTotal}
                                        orderData={orderDataWithLocations}
                                        glCodesList={orgData.glCodesList}
                                        handleEditItem={handleEditItem}
                                        cancelEditItem={cancelEditItem}
                                        editSave={editSave}
                                        removeEditingVals={false}
                                        refreshParentDetails={() => getBillingDetails(currentInvoice?.customer_order_id)}
                                        refreshAccessorial={getAccessorials}
                                        screenType={"InvoiceDetailsDrawer"}
                                    />
                                </Row>
                                <Row className="charges-table-view">
                                    <ChargesSection
                                        title={I18n.t("invoices.accessorial_charges")}
                                        chargeType="accessorial_charges"
                                        section={currentInvoice?.accessorial_charges?.[0] || {}}
                                        //locations={currentInvoice?.orders_info || []}
                                        //locations={currentInvoice?.order_info?.locations || []}
                                        locations={orderDataWithLocations?.locations || []}
                                        isTemplateZoneBilling={false}
                                        isInvoiceLocked={isInvoiceLocked}
                                        isReadyOnly={false}
                                        showActions={showActions}
                                        isOnHold={isOnHold}
                                        isAdjusted={false}
                                        handleAddItem={handleAddItem}
                                        handleItemsChange={(index, element, value, orderNo) =>
                                            handleItemsChange(index, element, value, "accessorial_charges", orderNo)
                                        }
                                        handleDeleteClick={handleDeleteClick}
                                        handleInputSaveItem={handleInputSaveItem}
                                        findSectionTotal={findSectionTotal}
                                        orderData={orderDataWithLocations}
                                        glCodesList={orgData.glCodesList}
                                        handleEditItem={handleEditItem}
                                        cancelEditItem={cancelEditItem}
                                        editSave={editSave}
                                        removeEditingVals={false}
                                        accessorials={accessorials}
                                        invoice={currentInvoice}
                                        technicians={technicians}
                                        drivers={drivers}
                                        orgId={userStore.getStateValue("selectedOrg")}
                                        accountId={account?.id}
                                        orderId={order?.id}
                                        reqData={accessorials}
                                        orgrules={orgData?.orgRules?.org_billing_rules || {}}
                                        handleRecordUpdate={() => {}}
                                        // refreshParentDetails={() => {}}
                                        // refreshAccessorial={() => {}}
                                        refreshParentDetails={() => getBillingDetails(currentInvoice?.customer_order_id)}
                                        refreshAccessorial={getAccessorials}
                                        orgComponents={[]}
                                        displayComponents={[]}
                                        accountComponentAccessorial={[]}
                                        orderAccessorials={[]}
                                        authorizeDetails={{}}
                                        slotConfig={{}}
                                        reapproveBilling={() => {}}
                                        isMilitaryTime={false}
                                        screenType={"InvoiceDetailsDrawer"}
                                    />
                                </Row>
                                <Row className="charges-table-view">
                                    <ChargesSection
                                        title={I18n.t("invoices.adjustments")}
                                        chargeType="adjustment_charges"
                                        section={currentInvoice?.adjustment_charges?.[0] || {}}
                                        //locations={currentInvoice?.orders_info || []}
                                        //locations={currentInvoice?.order_info?.locations || []}
                                        locations={orderDataWithLocations?.locations || []}
                                        isTemplateZoneBilling={false}
                                        isInvoiceLocked={isInvoiceLocked}
                                        isReadyOnly={false}
                                        showActions={showActions && currentInvoice?.status !== "APPROVED"}
                                        isOnHold={isOnHold}
                                        isAdjusted={false}
                                        handleAddItem={handleAddItem}
                                        handleItemsChange={(index, element, value, orderNo) =>
                                            handleItemsChange(index, element, value, "adjustment_charges", orderNo)
                                        }
                                        handleDeleteClick={handleDeleteClick}
                                        handleInputSaveItem={handleInputSaveItem}
                                        findSectionTotal={findSectionTotal}
                                        orderData={orderDataWithLocations}
                                        glCodesList={orgData.glCodesList}
                                        handleEditItem={handleEditItem}
                                        cancelEditItem={cancelEditItem}
                                        editSave={editSave}
                                        removeEditingVals={false}
                                        canAddCharges={!isInvoiceLocked && currentInvoice?.status !== "APPROVED"}
                                        refreshParentDetails={() => getBillingDetails(currentInvoice?.customer_order_id)}
                                        refreshAccessorial={getAccessorials}
                                        screenType={"InvoiceDetailsDrawer"}
                                    />
                                </Row>
                                <Row>
                                    <table width="100%" className="total-amount-section">
                                        <tbody>
                                            <tr>
                                                <td width="245px">{""}</td>
                                                <td
                                                    width="148px"
                                                    className="total-amount alignRight"
                                                >
                                                    Job Total
                                                </td>
                                                <td
                                                    width="148px"
                                                    className="total-amount alignRight"
                                                >
                                                    {/* {checkNegitive(currentInvoice?.total_amount)} */}
                                                    {/* {checkNegitive(jobTotal)} */}
                                                    {checkNegitive(useJobTotal(currentInvoice, order, decimalPoints))}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Row>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tab="Driver Pays" key="driverPays">
                        <div className="invoice-details-body">
                            <div className="invoice-details-box">
                                <InvoiceDriverPay
                                    drivers={drivers}
                                    currentInvoice={currentInvoice}
                                    isLocked={isLocked}
                                    glCodesList={orgData.glCodesList}
                                    updateParentComponent={handleUpdateInvoice}
                                />
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tab="Activities" key="activities">
                        <div className="invoice-details-body">
                            <div className="invoice-details-box">
                                {!_.isEmpty(billingActivitiesList) ?
                                    <>
                                        <Row type="flex" gutter={[16, 16]}>
                                            <Col span={12}>
                                                <Search
                                                    onChange={(e) => searchBar(e)}
                                                    placeholder={I18n.t("general.search")}
                                                    // onSearch={value => this.searchBar(value)}
                                                    style={{ width: '100%' }}
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <div
                                                    style={{ display: "flex", justifyContent: "center" }}
                                                >
                                                    <label
                                                        style={{ marginRight: "10px", marginTop: "2px" }}
                                                    >
                                                        Order(s):
                                                    </label>
                                                    <Select
                                                        className={
                                                            filteredOrdersForActivities.length ===
                                                                1
                                                                ? "one-tag"
                                                                : ""
                                                        }
                                                        value={filteredOrdersForActivities}
                                                        onChange={(value) => filterOrderNos(value)}
                                                        mode="multiple"
                                                        maxTagCount={3}
                                                        style={{ width: "80%" }} // Reduced width
                                                        showSearch
                                                        filterOption={(input, option) =>
                                                            option.props.children
                                                                .toLowerCase()
                                                                .indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {filterOrderIds.map((order) => (
                                                            <Select.Option
                                                                key={order.order_number}
                                                                value={order.order_number}
                                                            >
                                                                {order.order_number}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="invoice-activities-list">
                                        <InvoiceActivities
                                            data={
                                                !_.isEmpty(filteredBillingActivitiesList)
                                                    ? filteredBillingActivitiesList
                                                    : ''
                                            }
                                        />
                                        </Row>
                                    </>
                                    :
                                    <div style={{ textAlign: "center" }}>No Activies Recorded</div>
                                }
                            </div>
                        </div>
                    </TabPane>
                </Tabs>
                {showEmailModal && renderEmailModal()}
            </Spin>
        </>
    )
}

export default InvoiceDetailsDrawer